export default "__VITE_ASSET__BJMC9iO6__"